import { useAuthStore } from '@/stores/auth';
import { BRAND } from '@/models/auth/permissions.enum';

export const NO_ACCESS_TO_CONTENT_TAG_TOOLTIP = `Content tags are only available to brands in the Enterprise plan`;

export function canAccessContentTags() {
  const authStore = useAuthStore();
  return authStore.guard(BRAND.TAGS.CAN_ACCESS_CONTENT_TAGS);
}
